export class UserMeta {
    public tokenLastChanged: number;

    constructor(initialValues?: Partial<UserMeta>) {
        this.tokenLastChanged = initialValues?.tokenLastChanged ?? 1;
    }
}
